<span *ngIf="!translationKeys.length">{{ 'common.noValue' | translate }}</span>
<span *ngFor="let tranlsationKey of translationKeys; let i = index">
  <span [title]="tranlsationKey | translate">{{ tranlsationKey | translate }}</span>
  <span *ngIf="isNotLastElement(i)">&#44;&nbsp;</span>
</span>
